import { CartLinesUpdateEvent } from '@shopify/events';
let refreshing = false, again = false;
window.addEventListener('geight:cart-changed', async () => {
  if(refreshing){again=true;return;}
  refreshing=true;
  try {
    const root=window.Shopify?.routes?.root || '/';
    const ids=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(x=>x.dataset.sectionId))].slice(0,5);
    const [cart,sections]=await Promise.all([
      fetch(root+'cart.js',{cache:'no-store'}).then(r=>{if(!r.ok)throw new Error();return r.json();}),
      ids.length ? fetch(root+'?sections='+encodeURIComponent(ids.join(',')),{cache:'no-store'}).then(r=>{if(!r.ok)throw new Error();return r.json();}) : Promise.resolve({})
    ]);
    document.dispatchEvent(new CartLinesUpdateEvent({context:'cart',action:'add',promise:Promise.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{source:'geight-purchasing',items:cart.items,itemCount:cart.item_count,sections}})}));
  } catch(_) {
    // Actual add results are reported separately. Never repeat a cart write to repair UI.
    document.querySelectorAll('[data-geight-status]').forEach(x=>{if(x.textContent)x.textContent+=' Open your cart to review the latest quantities.';});
  } finally {refreshing=false;if(again){again=false;window.dispatchEvent(new Event('geight:cart-changed'));}}
});
